import '@/shared/components/gameStyleBoundary/styles.scss';

import type { ReactNode } from 'react';

type GameStyleBoundaryProps = {
	children: ReactNode;
};

const GameStyleBoundary = ({ children }: GameStyleBoundaryProps) => {
	return <div className="fw-web-game">{children}</div>;
};

export default GameStyleBoundary;
